<template>
	<div>
		<Header />
		<div class="bannerWrap">
			<img class="bannerImg" :src="`${imgPath}/static/assets/img/notice/banner.jpg?2`" />
			<cloud />
		</div>
		<div class="notice-content">
            <div class="crumbWrap"><span @click="link2Route(crumbs1)">{{crumbs1.name}}</span> &gt; <span @click="link2Route(crumbs2)">{{crumbs2.name}}</span> &gt; <span>{{ $t('text') }}</span></div>
            <div class="contentWrap">
                <p class="title">{{detail.title}}</p>
                <p class="date">{{detail.publish_at|timeFormatString}}</p>
                <div class="desc" v-html="detail.content"></div>
            </div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
                id:this.$route.params.id,
                detail:{},
                crumbs1:{},
                crumbs2:{}
			}
		},
		mounted(){
			this.getNoticeDetail()
		},
		methods: {
			getNoticeDetail(){
                this.$api.getNoticeDetail({id:this.id,lang:localStorage.getItem('language') || 'zh-cn'}).then(res=>{
                    if(!res.code){
                        this.detail = res.data.detail;
                        this.crumbs1 = res.data.crumbs[0];
                        this.crumbs2 = res.data.crumbs[1];
                        return false
                    }
                });
            },
            link2Route(data){
                if(data.id === 3){
                    this.$router.push({name:'notice'})
                }else{
                    this.$router.push({name:'noticeList',params:{type:data.id}})
                }
            }
		}
	}
</script>
<style>
.desc img {
    width: 100% !important;
    height: auto !important;
}
.desc p {
    margin-bottom: 0.1rem;
}
</style>
<style lang="scss" scoped>
	.bannerWrap{
		position: relative;
		width: 100%;
        height: 5.19rem;
		.bannerImg {
			width: 100%;
		}
	}
	.notice-content{
		padding: 0 0.82rem;
        box-sizing: border-box;
        .crumbWrap {
            font-size: 0.24rem;
            color: #7A7A7A;
            margin-top: 0.52rem;
        }
        .contentWrap {
            .title{
                font-size: 0.26rem;
                font-weight: bold;
                color: #000000;
                margin-top: 0.7rem;
            }
            .date{
                font-size: 0.22rem;;
                color: #7A7A7A;
                margin-top: 0.27rem;
            }
            .desc{
                font-size: 0.24rem;
                color: #7A7A7A;
                margin-top: 0.6rem;
                word-break: break-all;
                line-height: 0.4rem;
            }
        }
	}
</style>


// WEBPACK FOOTER //
// src/views/notice/detail.vue